import styled from 'styled-components';
import { themeGet } from 'styled-system';

const SocialShareWrapper = styled.div`
  background-color: ${themeGet('color.4')};
  color: ${themeGet('color.1')};
  padding: 15px 0;
  margin-top: 5%;

  .story-wrap {
    display: flex;
    flex-flow: row wrap;
    align-items: center;
    width: 80%;
    max-width: 800px;
    margin: auto;
    padding: 25px 0;
  }

  h4 {
    flex: 1;
    margin: 0;
    font-weight: 700;
    font-style: italic;
    font-size: 1.5rem;

    @media screen and (max-width: 600px) {
      flex: 100% 1;
    }
  }

  .social-networks {
    flex: 1;
    display: flex;
    justify-content: flex-end;

    @media screen and (max-width: 600px) {
      flex: 100% 1;
      justify-content: flex-start;
      margin-top: 20px;
    }

    > .SocialMediaShareButton {
      margin-left: 10px;
      cursor: pointer;
      transition: 0.3s ease-in;

      &:hover {
        transform: scale(1.05);
      }

      &:focus {
        outline: 0;
      }

      @media screen and (max-width: 600px) {
        margin-left: 0;
        margin-right: 15px;
      }
    }
  }
`;

export default SocialShareWrapper;
